import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const STEPS = [
  "Analizuję temat...",
  "Generuję streszczenie...",
  "Wyodrębniam kluczowe pojęcia...",
  "Formułuję pytania quizowe...",
  "Ostatnie szlify..."
];

export default function LoadingScreen({ label = "Przygotowuję materiał..." }) {
  const [step, setStep] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setStep((s) => (s + 1) % STEPS.length), 1400);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center" data-testid="loading-screen">
      <div className="max-w-md w-full px-6 text-center ss-fadein">
        <div className="w-16 h-16 mx-auto mb-6 rounded-3xl bg-[#FFD600] flex items-center justify-center btn-yellow-glow">
          <Sparkles className="w-8 h-8 text-slate-900" strokeWidth={2.5} />
        </div>
        <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">{label}</h2>
        <p className="mt-3 text-slate-500 text-sm min-h-[20px]" data-testid="loading-substep">{STEPS[step]}</p>

        <div className="flex items-center justify-center gap-1.5 mt-8">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="w-2.5 h-2.5 rounded-full bg-[#FFD600] ss-dot"
              style={{ animationDelay: `${i * 0.18}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
